export default {
  titles: {
    time: {
      count: {
        visit: 'Number of HistoPad visits per day',
        collected_treasure_count: 'Number of collected treasures per day',
        email: 'Number of collected email addresses per day',
        comment: 'Number of collected comments per day',
        histomaton_file: 'Number of HistoSelfies taken per day',
        affluence: 'HistoPad attendance peaks per day',
        is_crash: 'Number of HistoPad crashes per day',
        upload: 'Number of uploaded logs per day',
        uploaded_time: 'Number of first time uploaded logs per day',
        uploaded_count: 'Number of uploaded logs per day',
        duplicate: 'Number of duplicated visits per day',
        hotspot: 'Number of viewed {0} per day',
        cartel: 'Number of viewed {0} per day',
        immersive: 'Number of viewed {0} per day',
        augmentedvisit: 'Number of viewed {0} per day',
        interactiveobject: 'Number of viewed {0} per day',
        interactivebuilding: 'Number of viewed {0} per day',
        email_delivered: 'Number of sent after visit emails per day',
        email_open: 'Number of after visit email openings per day',
        email_click: 'Number of clicks in the after visit emails per day',
        email_delivered_session:
          'Number of HistoPad visits that received email after visit over time',
        email_open_session: 'Number of HistoPad visits that opened the email after visit over time',
        email_click_session: 'Number of HistoPad visits that clicked in mail after visit over time',
        survey_answer: 'Number of started surveys per day',
        inactivity_time: 'Inactivity time',
        area_visit: 'Number of HistoPad visits per day in the area',
        stuck_log: 'Number of stuck logs per day',
        warning: 'Number of warnings per day',
      },
      average_count: {
        visit: 'Average number of HistoPad visits per day',
        email: 'Average number of email addresses collected per day',
        comment: 'Average number of comments left by visitors per day',
        histomaton_file: 'Average number of HistoSelfies taken per day',
        affluence: 'Average number of attendances peaks per day',
        is_crash: 'Average number of crashes per day',
        upload: 'History of the average number of uploaded logs',
        uploaded_time: 'Average number of first time uploaded logs per day',
        uploaded_count: 'History of the average of uploaded logs',
        duplicate: 'Average number of uploaded logs per day',
        histopad_rating: 'Average HistoPad rating per day',
        visit_rating: 'Average visit rating per day',
        collected_treasure_count: 'Average number of collected treasures per day',
        hotspot: 'Average number of viewed {0} per visit per day',
        cartel: 'Average number of viewed {0} per visit per day',
        immersive: 'Average number of viewed {0} per visit per day',
        augmentedvisit: 'Average number of viewed {0} per visit per day',
        interactiveobject: 'Average number of viewed {0} per visit per day',
        interactivebuilding: 'Average number of viewed {0} per visit per day',
        interactivecharacter: 'Average number of viewed {0} per visit per day',
        sequence: 'Average number of viewed {0} per visit per day',
        email_delivered: 'Average number of sent after visit emails per day',
        email_open: 'Average number of after visit email openings per day',
        email_click: 'Average number of clicks in the after visit emails per day',
        survey_answer: 'Average number of clicks in the after visit emails per day',
        rotation: 'Average number of HistoPad turnovers per day',
        inactivity_time: 'Average inactivity time per day',
        warning: 'Average number of warnings per day',
        max_temperature: 'Maximum temperature average reached per day',
        min_temperature: 'Minimum temperature average reached per day',
        max_level: 'Maximum battery level average reached per day',
        min_level: 'Minimum battery level average reached per day',
        max_memory_level: 'Maximum memory level average reached per day',
        min_memory_level: 'Minimum memory level average reached per day',
        max_temperature_gradient: 'Average maximum slope of temperatures per day',
        min_level_gradient: 'Average maximum slope of battery level per day',
        max_memory_level_gradient: 'Average maximum slope of memory level per day',
      },
      average_time: {
        visit: 'Average duration of visit per day',
        hotspot: 'Average time spent in {0} per visit per day',
        cartel: 'Average time spent in {0} per visit per day',
        immersive: 'Average time spent in {0} per visit per day',
        augmentedvisit: 'Average time spent in {0} per visit per day',
        interactiveobject: 'Average time spent in {0} per visit per day',
        interactivebuilding: 'Average time spent in {0} per visit per day',
        interactivecharacter: 'Average time spent in {0} per visit per day',
        sequence: 'Average time spent in {0} per visit per day',
        email_open: 'Average time before the email is opened per day',
        route_duration: 'History of average route duration',
        inactivity_time: 'History of average inactivity',
        area_visit: 'History of the average visit time in the area',
      },
      max_time: {
        visit: 'Maximum duration of visits per day',
      },
      min_time: {
        visit: 'Minimum duration of visits per day',
      },
      percentage: {
        email: 'Percentage of visitors who left their email addresses per day',
        comment: 'Percentage of visitors who left a comment per day',
        histomaton_file: 'Percentage of visitors who took the HistoSelfie per day',
        is_crash: 'Percentage of crashes per day',
        histopad_rating: 'Percentage of visitors who rated the HistoPad per day',
        visit_rating: 'Percentage of visitors who rated the visit per day',
        collected_treasure_count: 'Percentage of visits with treasures found per day',
        upload: 'History of the percentage of uploaded logs over unique visits',
        uploaded_count: 'Percentage of uploaded logs per day',
        duplicate: 'Percentage of duplicated visits per day',
        email_delivered: 'Percentage of sent after visit email per day',
        email_open: 'Percentage of after visit email openings per day',
        email_click: 'Percentage of click in the after visit email per day',
        email_delivered_session:
          'History of the percentage of visits that received email after visit',
        email_open_session: 'History of the percentage of visits that opened the email after visit',
        email_click_session:
          'History of the percentage of visits that clicked in the email after visit',
        survey_answer: 'Percentage of started surveys per day',
        route_duration: 'History of the route duration rate over the visit duration',
        inactivity_time: 'History of inactivity rate',
        area_visit: 'History of the percentage of HistoPad visits per day in the area',
        warning: 'Percentage of session with warnings per day',
      },
    },
    indicator: {
      count: {
        visit: 'Number of HistoPad visits',
        collected_treasure_count: 'Number of collected treasures',
        email: 'Number of collected email addresses',
        comment: 'Number of collected comments',
        histomaton_file: 'Number of HistoSelfies taken',
        affluence: 'Number of attendance peaks',
        is_crash: 'Number of crash',
        upload: 'Number of uploaded logs',
        uploaded_time: 'Number of first time uploaded logs',
        uploaded_count: 'Number of uploaded logs',
        duplicate: 'Number of duplicated visits',
        hotspot: 'Number of viewed {0}',
        cartel: 'Number of viewed {0}',
        immersive: 'Number of viewed {0}',
        augmentedvisit: 'Number of viewed {0}',
        interactiveobject: 'Number of viewed {0}',
        interactivebuilding: 'Number of viewed {0}',
        interactivecharacter: 'Number of viewed {0}',
        sequence: 'Number of viewed {0}',
        email_delivered: 'Number of sent after visit emails',
        email_open: 'Number of after visit email openings',
        email_click: 'Number of clicks in the after visit emails',
        email_delivered_session: 'Number of visits that received email after visit',
        email_open_session: 'Number of visits that opened the email after visit',
        email_click_session: 'Number of visits that clicked in the email after visit',
        survey_answer: 'Number of started surveys',
        area_visit: 'Number of HistoPad visits in the area',
        stuck_log: 'Number of stuck logs',
        warning: 'Number of warnings',
      },
      average_count: {
        visit: 'Average number of HistoPad visits',
        email: 'Average number of collected email addresses',
        comment: 'Average number of collected comments',
        histomaton_file: 'Average number of collected HistoSelfies',
        affluence: 'Average attendance peaks',
        is_crash: 'Average crashes',
        upload: 'Average uploaded logs',
        uploaded_time: 'Average number of first time uploaded logs',
        uploaded_count: 'Average number of uploaded logs',
        duplicate: 'Average number of duplicated visits',
        histopad_rating: 'Average HistoPad rating',
        visit_rating: 'Average visit rating',
        collected_treasure_count: 'Average number of collected treasures',
        hotspot: 'Average number of viewed {0} per visit',
        cartel: 'Average number of viewed {0} per visit',
        immersive: 'Average number of viewed {0} per visit',
        augmentedvisit: 'Average number of viewed {0} per visit',
        interactiveobject: 'Average number of viewed {0} per visit',
        interactivebuilding: 'Average number of viewed {0} per visit',
        interactivecharacter: 'Average number of viewed {0} per visit',
        sequence: 'Average number of viewed {0} per visit',
        email_delivered: 'Average number of sent after visit emails',
        email_open: 'Average number of after visit emails openings',
        email_click: 'Average number of clicks in the after visit emails',
        email_delivered_session: 'Average number of visits that received email after visit',
        email_open_session: 'Average number of visits that opened the email after visit',
        email_click_session: 'Average number of visits that clicked in the email after visit',
        survey_answer: 'Average number of started surveys',
        area_visit: 'Average number of visit in the area',
        warning: 'Average number of warnings',
        max_temperature: 'Maximum temperature average reached',
        min_temperature: 'Minimum temperature average reached',
        max_level: 'Maximum battery level average reached',
        min_level: 'Minimum battery level average reached',
        max_memory_level: 'Maximum memory level average reached',
        min_memory_level: 'Minimum memory level average reached',
        max_temperature_gradient: 'Average maximum slope of temperatures',
        min_level_gradient: 'Average maximum slope of battery level',
        max_memory_level_gradient: 'Average maximum slope of memory level',
      },
      average_time: {
        visit: 'Average duration of visits',
        hotspot: 'Average time spent in {0} per visit',
        cartel: 'Average time spent in {0} per visit',
        immersive: 'Average time spent in {0} per visit',
        augmentedvisit: 'Average time spent in {0} per visit',
        interactiveobject: 'Average time spent in {0} per visit',
        interactivebuilding: 'Average time spent in {0} per visit',
        interactivecharacter: 'Average time spent in {0} per visit',
        sequence: 'Average time spent in {0} per visit',
        email_open: 'Average time before the email is opened',
        route_duration: 'Average route duration',
        inactivity_time: 'Average inactivity duration',
        area_visit: 'Average duration in the area',
      },
      max_time: {
        visit: 'Maximum duration of visits per day',
      },
      min_time: {
        visit: 'Minimum duration of visits per day',
      },
      percentage: {
        email: 'Percentage of visitors who left their email addresses',
        comment: 'Percentage of visitors who left a comment',
        histomaton_file: 'Percentage of visitors who took the HistoSelfie',
        is_crash: 'Percentage of crashes',
        histopad_rating: 'Percentage of visitors who rated the HistoPad',
        visit_rating: 'Percentage of visitors who rated the visit per day',
        collected_treasure_count: 'Percentage of visits with treasures found per day',
        upload: 'Percentage of uploaded logs over uploaded unique visits',
        uploaded_count: 'Percentage of uploaded logs',
        duplicate: 'Percentage of duplicated visits',
        email_delivered: 'Percentage of sent after visit email',
        email_open: 'Percentage of after visit email openings',
        email_click: 'Percentage of click in the after visit email',
        email_delivered_session: 'Percentage of visits that received email after visit',
        email_open_session: 'Percentage of visits that opened the email after visit',
        email_click_session: 'Percentage of visits that clicked in the email after visit',
        survey_answer: 'Percentage of started surveys',
        route_duration: 'Route duration rate over the visit duration',
        inactivity_time: 'Inactivity rate',
        area_visit: 'Percentage of HistoPad visits in the area',
        warning: 'Percentage of sessions with warnings',
      },
    },
    distribution: {
      visit: 'Distribution of visits',
      email: 'Distribution of visits with email',
      comment: 'Distribution of visits with comment',
      histomaton_file: 'Distribution of visits with HistoSelfies',
      is_crash: 'Crash distribution',
      upload: 'Uploaded logs distribution',
      uploaded_time: 'Uploaded visits distribution',
      uploaded_count: 'Uploaded logs distribution',
      duplicate: 'Duplicated visits distribution',
      email_delivered: 'Distribution of after visit email sent',
      email_open: 'Distribution of after visit email openings',
      email_click: 'Distribution of clicks in after visit emails',
      email_delivered_session: 'Distribution of visits that received email after visit',
      email_open_session: 'Distribution of visits that opened the email after visit',
      email_click_session: 'Distribution of visits that clicked in the email after visit',
      collected_treasure_count: 'Distribution of collected treasures',
      survey_answer: 'Distribution of started surveys',
      stuck_log: 'Distribution of stuck logs',
      warning: 'Distribution of warnings',
    },
    day: {
      count: {
        visit: 'History of HistoPad visits during a day',
        email: 'History of email addresses collected during a day',
        comment: 'History of comments left during a day',
        histomaton_file: 'History of HistoSelfie during a day',
        affluence: 'History of affluences peaks during a day',
        is_crash: 'Crash history during a day',
        uploaded_time: 'Uploaded logs history during a day',
        upload: 'Uploaded logs during a day',
      },
    },
    rotation: {
      count: {
        visit: 'Number of turnovers per tablet',
        email: 'Number of turnovers with email left per tablet',
        comment: 'Number of turnovers with comment left per tablet',
        histomaton_file: 'Number of turnovers with HistoSelfie per tablet',
        is_crash: 'Number of turnovers with crash per tablet',
      },
    },
    matrix: {
      count: {
        affluence: 'Heatmap of visitors affluence over time',
      },
    },
  },
}
